import React from 'react';
import { ChannelLayout } from 'core/models/channel';
import { LatencyPanel } from 'components/views/molecules/LatencyPanel/LatencyPanel';
import WindowDialog from 'react-new-window';
import { useLatencyMeasure, useLatencyMeasurePoints, useUpdateLatencyMeasures } from 'services/latency/useLatencyMeasure';

export type StatsProps = React.PropsWithChildren<{
    layout?: ChannelLayout;
    onClose: () => void;
}>

export function LatencyWindow(props: StatsProps) {
    const { layout, onClose } = props;

    const latencyMeasures = useLatencyMeasure(layout);
    const { points, addPoint, clearPoints } = useLatencyMeasurePoints(latencyMeasures);
    const currentMeasurements = useUpdateLatencyMeasures(latencyMeasures, 1000);

    return (
        <WindowDialog onUnload={onClose} copyStyles={true}>
            <LatencyPanel
                currentMeasurements={currentMeasurements}
                points={points} addPoint={addPoint} clearPoints={clearPoints}
            />
        </WindowDialog>
    );
}
